import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Bot } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const AIAgentNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'AI Agent'}
        icon={Bot}
        colorClass="from-violet-500 to-violet-700"
        bgClass="bg-gradient-to-br from-violet-500 to-violet-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={true}
        isTarget={true}
        threeSidedHandles={true}
        rowsProcessed={data?.rowsAffected}
    />
));
AIAgentNode.displayName = 'AIAgentNode';
export default AIAgentNode;
